import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { CONSENT_REQUIRED_KEY } from '@/constants/app.constant'

const ConsentGate = () => {
    const location = useLocation()
    const consentRequired = sessionStorage.getItem(CONSENT_REQUIRED_KEY) === '1'

    if (consentRequired && location.pathname !== '/consent') {
        return <Navigate replace to="/consent" />
    }

    if (location.pathname.startsWith('/consent/')) {
        return <Navigate replace to="/consent" />
    }

    return <Outlet />
}

export default ConsentGate
